import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { trackLoginClickEvent } from '../../services/tracking/pulseEvents';
import { login } from '../../services/schibstedAccount';
import { Button } from '../Button/Button';

import type { ButtonProps } from '../Button/Button';
import type { FC } from 'react';

type LoginButtonProps = {
  size?: ButtonProps['size'];
};

const LoginButton: FC<LoginButtonProps> = ({ size = 'large' }) => {
  const { t } = useTranslation();

  const label = t('Log in');

  const handleLoginClick = useCallback(() => {
    trackLoginClickEvent({
      button: {
        elementType: 'LoginButton',
        title: label,
      },
    });

    login({ source: 'paywall-splash' });
  }, [label]);

  return (
    <Button size={size} variant="outlined" rounded onClick={handleLoginClick}>
      {label}
    </Button>
  );
};

export { LoginButton };
